import classNames from 'classnames';
import BaseInputNumber from 'components/atoms/base-input-number';
import React from 'react';

import s from './styles.module.scss';
import UncheckableRadioItem from './uncheckableRadioItem';

import type { FormikProps } from 'formik';
import type { FC } from 'react';
import type { IOptionProps } from './types';

interface InputNumberItemProps<T = any> {
  option: IOptionProps;
  formik: FormikProps<T>;
}

const InputNumberItem: FC<InputNumberItemProps> = ({ option, formik }) => {
  const isShowErrorMessage = Object.keys(formik.errors).includes(
    String(option.value),
  );

  const itemClassNames = classNames(s['extra-num-input'], {
    [s.error]: isShowErrorMessage,
  });
  const style = option?.width ? { width: option?.width } : undefined;

  return (
    <React.Fragment key={option.key}>
      {option.extraType === 'inputNumber' && (
        <div className={itemClassNames}>
          <label>
            <span>{option.label}</span>
          </label>
          <BaseInputNumber
            style={style}
            placeholder="0.0"
            onChange={(value) =>
              formik.setFieldValue(option.value as string, value)
            }
            value={formik.values[option.value as string]}
          />
        </div>
      )}
      {option.extraType === 'inputNumberRadio' && (
        <div className={s['extra-num-radio']}>
          <label>
            <span>{option.label}</span>
          </label>
          <UncheckableRadioItem
            options={[
              { label: 'PRN', value: 'PRN', key: 'PRN' },
              {
                label: 'Continuous',
                value: 'Continuous',
                key: 'Continuous',
              },
            ]}
            disabled={formik.values.homeO2Setting === null}
            name={option.value as string}
            value={formik.values[option.value as string]}
            formik={formik}
            type="radio-line"
          />
        </div>
      )}
    </React.Fragment>
  );
};
export default InputNumberItem;
